export default {
  getIndustryTypes: state => state.industryTypes,
}
